(() => {
  const mounted = new WeakSet();
  function mount(scope = document) {
    const roots = [...(scope.matches?.('[data-bnc-product-media]') ? [scope] : []), ...scope.querySelectorAll('[data-bnc-product-media]')];
    for (const root of roots) {
      if (mounted.has(root)) continue;
      mounted.add(root);
      const area = root.closest('#MainContent') || document;
      const gallery = area.querySelector('media-gallery');
      if (!gallery) continue;
      gallery.classList.add('bnc-caps-gallery');
      const configs = [...root.querySelectorAll('[data-bnc-model-id]')];
      const configured = new WeakSet();
      const lifetime = new AbortController();
      const mobile = window.matchMedia('(max-width:749px), (hover:none) and (pointer:coarse)');
      const configFor = node => {
        const id = node.closest('[data-media-id]')?.dataset.mediaId || '';
        return configs.find(config => id === config.dataset.bncModelId || id.endsWith(`-${config.dataset.bncModelId}`));
      };
      const setPoster = (image, config) => {
        if (image.dataset.bncPosterReady) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = config.dataset.bncPoster;
        image.dataset.bncPosterReady = 'true';
      };
      const configure = () => {
        area.querySelectorAll('product-model').forEach(host => {
          const config = configFor(host);
          if (!config) return;
          host.classList.add('bnc-caps-model');
          host.querySelectorAll('.deferred-media__poster img').forEach(image => setPoster(image, config));
          const item = host.closest('.product__media-item');
          item?.querySelectorAll('.product__modal-opener--model img').forEach(image => setPoster(image, config));
          const models = [...host.querySelectorAll('model-viewer')];
          host.querySelectorAll('template').forEach(template => models.push(...template.content.querySelectorAll('model-viewer')));
          models.forEach(model => {
            if (configured.has(model)) return;
            configured.add(model);
            model.setAttribute('camera-controls', '');
            model.setAttribute('touch-action', 'pan-y');
            model.setAttribute('environment-image', mobile.matches ? 'neutral' : root.dataset.environmentUrl || 'neutral');
            model.setAttribute('exposure', mobile.matches ? '1' : String(Math.SQRT1_2));
            model.setAttribute('poster', config.dataset.bncPoster);
            model.addEventListener('error', () => {
              host.dataset.bncFailed = 'true';
              const poster = host.querySelector('.deferred-media__poster');
              if (poster && root.dataset.fallbackLabel) poster.setAttribute('aria-label', root.dataset.fallbackLabel);
            }, { signal: lifetime.signal });
            model.addEventListener('load', () => {
              delete host.dataset.bncFailed;
            }, { signal: lifetime.signal });
          });
        });
      };
      configure();
      const observer = new MutationObserver(configure);
      observer.observe(area, { childList:true, subtree:true });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target === root || event.target.contains?.(root)) {
          observer.disconnect();
          lifetime.abort();
        }
      }, { signal:lifetime.signal });
    }
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
